// extracted by mini-css-extract-plugin
export default {"legend":"YamazumiNebReport_legend__gQjBl","tactTime":"YamazumiNebReport_tactTime__OWuCU","pitchTime":"YamazumiNebReport_pitchTime__WJWn5"};